<div class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'ORDERS.BUYER_COLUMN_LABEL' | translate }}</h3>
    </div>
    <div>
      <button
        mat-icon-button
        class="sp-icon__button sp-icon__button-dark sp-margin__left"
        [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate"
        (click)="onDetailsClick(order?.buyer_id || '-')">
        <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
      </button>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-store-details-general-buyer__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-info-copy
      [label]="'BUYERS.ID_COLUMN_LABEL'"
      [content]="order?.buyer_id || '-'"
      [content_class]="'sp-text__ellipsized'"
      [is_shrinked_id]="true"></app-shared-info-copy>
    <app-shared-info
      [label]="'ORDERS.BUYER_NAME_LABEL'"
      [content]="getBuyerFullName()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'ORDERS.BUYER_PHONE_LABEL'"
      [content]="getFormattedPhone()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'ORDERS.BUYER_EMAIL_LABEL'"
      [content]="order?.buyer_email || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-margin__top-x2">
    <app-shared-info
      [label]="'GENERAL.TAX_CODE'"
      [content]="order?.buyer_tax_code || '-'"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
</div>
